(function($) {

    var mainClass = '.webinar-presentation';
    var container = $(mainClass),
        slidesContainer = container.find(mainClass + '__slides-container'),
        slides = container.find(mainClass + '__slide'),
        prev = container.find(mainClass + '__prev'),
        next = container.find(mainClass + '__next'),
        ptr = 0,
        count = null,
        animationSpeed = 300;

    var presentation = {

        makeResize: function() {
            var height = $(slides.get(0)).height();
            slidesContainer.height(height);
        },

        goToPtr: function() {
            slides.stop();
            slides.fadeOut(animationSpeed);
            $(slides.get(ptr)).fadeIn(animationSpeed);
        },

        next: function() {
            var self = this;
            var lastPtr = ptr;

            ptr++;
            if(ptr >= count) {
                ptr = 0;
            }

            self.goToPtr();
        },

        prev: function() {
            var self = this;
            var lastPtr = ptr;

            ptr--;
            if(ptr < 0) {
                ptr = count - 1;
            }

            self.goToPtr();
        },

        init: function() {
            var self = this;

            if(!container.size()) return;

            var firstImage = $(slides.get(0)).find('img');
            var firstImageRaw = firstImage.get(0);

            if(firstImageRaw.complete && firstImageRaw.naturalHeight && firstImageRaw.naturalWidth) {
                self.makeResize();
            } else {
                firstImage.load(function() {
                    self.makeResize();
                });
            }

            count = slides.size();
            slides.hide();
            $(slides.get(0)).show();

            next.click(function() {
                self.next();
            });

            prev.click(function() {
                self.prev();
            });

            $(window).resize(function() {
                self.makeResize();
            })
        }

    };

    $(document).ready(function() {
        presentation.init();
    });

})(jQuery);

